module.exports = __webpack_public_path__ + "666e65f87d4717099f1c4af2eb6bc9a3.png";